// extracted by mini-css-extract-plugin
module.exports = {"brandLayoutWrapper":"BrandLayout_brandLayoutWrapper___HDWg","contentSection":"BrandLayout_contentSection__yQEmi"};